import React, { useEffect } from "react";
import LegalPageLayout from "@/components/LegalPageLayout";

export default function AGB() {
  useEffect(() => {
    document.title = "AGB — Rodex Berlin";
  }, []);

  return (
    <LegalPageLayout
      title="Allgemeine Geschäftsbedingungen"
      intro="AGB der Firma Rodex Berlin für die Durchführung von Schädlingsbekämpfungs­leistungen"
    >
      <section>
        <h2>§ 1 Geltungsbereich</h2>
        <p>
          (1) Die nachstehenden Allgemeinen Geschäftsbedingungen (AGB) gelten für sämtliche
          Verträge zwischen Rodex Berlin (nachfolgend &bdquo;Auftragnehmer&ldquo;) und seinen Auftraggebern
          (nachfolgend &bdquo;Auftraggeber&ldquo;) über die Erbringung von Leistungen im Bereich der
          Nagetierbekämpfung, Befallsdiagnose, Prävention, Dauerüberwachung sowie damit
          zusammenhängenden Gutachten- und Dokumentationsleistungen.
        </p>
        <p>
          (2) Abweichende, entgegenstehende oder ergänzende AGB des Auftraggebers werden nur dann
          und insoweit Vertragsbestandteil, als der Auftragnehmer ihrer Geltung ausdrücklich
          schriftlich zugestimmt hat.
        </p>
      </section>

      <section>
        <h2>§ 2 Vertragsschluss</h2>
        <p>
          (1) Angebote des Auftragnehmers sind freibleibend und unverbindlich, sofern sie nicht
          ausdrücklich als verbindlich gekennzeichnet sind.
        </p>
        <p>
          (2) Mit Erteilung des Auftrags durch den Auftraggeber (schriftlich, per E-Mail,
          telefonisch oder durch entsprechende Handlung) kommt ein Vertrag auf Grundlage des
          abgegebenen Angebots zustande.
        </p>
      </section>

      <section>
        <h2>§ 3 Leistungsumfang</h2>
        <p>
          (1) Der Umfang der zu erbringenden Leistungen ergibt sich aus dem schriftlichen
          Festpreisangebot. Mehr- und Folgeleistungen, die über den ursprünglich vereinbarten Umfang
          hinausgehen, werden gesondert vereinbart und vergütet.
        </p>
        <p>
          (2) Der Auftragnehmer verpflichtet sich, alle Leistungen nach den anerkannten Regeln des
          Schädlingsbekämpfungs-Handwerks sowie unter Beachtung der Biozidverordnung, der BfR-Leitlinien,
          der LMHV und ggf. HACCP-Anforderungen zu erbringen.
        </p>
      </section>

      <section>
        <h2>§ 4 Mitwirkungspflichten des Auftraggebers</h2>
        <p>
          (1) Der Auftraggeber gewährt dem Auftragnehmer den für die Leistungserbringung notwendigen
          Zugang zu den betreffenden Räumlichkeiten und stellt sicher, dass befall­relevante Bereiche
          zugänglich sind.
        </p>
        <p>
          (2) Der Auftraggeber informiert den Auftragnehmer rechtzeitig über mögliche Gefahren
          (Allergien, Haustiere, Kinder, sensible Materialien) und befolgt die nach Durchführung der
          Bekämpfung erteilten Hinweise (z. B. Lüftungs-, Reinigungs- oder Sperrzeiten).
        </p>
        <p>
          (3) Der Auftraggeber ist verpflichtet, hygienische und bauliche Voraussetzungen zu
          schaffen bzw. aufrechtzuerhalten, die einen erneuten Befall verhindern. Hierzu zählen
          insbesondere ordnungsgemäße Müllentsorgung, Lebensmittellagerung und Bauinstandhaltung.
        </p>
      </section>

      <section>
        <h2>§ 5 Preise und Zahlung</h2>
        <p>
          (1) Es gelten die im Angebot ausgewiesenen Festpreise zzgl. der jeweils gültigen
          Umsatzsteuer.
        </p>
        <p>
          (2) Rechnungen sind, soweit nicht anders vereinbart, innerhalb von 14 Tagen nach
          Rechnungsdatum ohne Abzug zur Zahlung fällig.
        </p>
        <p>
          (3) Bei Zahlungsverzug ist der Auftragnehmer berechtigt, Verzugszinsen in gesetzlicher
          Höhe sowie ein Mahnpauschale von 5,00 € pro Mahnung zu verlangen.
        </p>
      </section>

      <section>
        <h2>§ 6 Termine und Fristen</h2>
        <p>
          (1) Termine werden individuell vereinbart. Der Auftragnehmer ist bemüht, vereinbarte
          Reaktionszeiten (insb. die Reaktion innerhalb 24 Stunden auf Anfragen) einzuhalten. Höhere
          Gewalt, Krankheit oder andere unverschuldete Umstände können zu einer angemessenen
          Verschiebung führen.
        </p>
        <p>
          (2) Vereinbarte Termine sind, soweit möglich, mindestens 24 Stunden vor dem Einsatz
          abzusagen. Bei späteren oder unentschuldigten Absagen kann der Auftragnehmer eine
          Ausfallpauschale in Höhe von 50 % des vereinbarten Festpreises berechnen.
        </p>
      </section>

      <section>
        <h2>§ 7 Gewährleistung</h2>
        <p>
          (1) Die Gewährleistung richtet sich nach den gesetzlichen Bestimmungen. Beanstandungen
          sind unverzüglich, spätestens innerhalb von 14 Tagen nach Leistungserbringung, schriftlich
          mitzuteilen.
        </p>
        <p>
          (2) Da Schädlingsbekämpfung als Werk- bzw. Dienstleistung von biologischen Faktoren
          abhängt, schuldet der Auftragnehmer eine fachgerechte Durchführung der Leistung, nicht
          jedoch einen darüber hinausgehenden, vom natürlichen Verhalten der Tiere und baulichen
          Gegebenheiten unabhängigen Erfolg. Eine Nachbehandlung im Rahmen vereinbarter
          Wartungsverträge bleibt hiervon unberührt.
        </p>
      </section>

      <section>
        <h2>§ 8 Haftung</h2>
        <p>
          (1) Der Auftragnehmer haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie bei
          Verletzung von Leben, Körper oder Gesundheit.
        </p>
        <p>
          (2) Bei einfacher Fahrlässigkeit haftet der Auftragnehmer nur bei Verletzung
          wesentlicher Vertragspflichten (Kardinalpflichten) und nur in Höhe des bei Vertragsschluss
          vorhersehbaren, typischen Schadens.
        </p>
        <p>
          (3) Eine weitergehende Haftung ist — soweit gesetzlich zulässig — ausgeschlossen. Dies
          gilt insbesondere für Folgeschäden, entgangenen Gewinn oder mittelbare Schäden.
        </p>
      </section>

      <section>
        <h2>§ 9 Datenschutz</h2>
        <p>
          Personenbezogene Daten des Auftraggebers werden im Rahmen der Auftragsabwicklung erhoben
          und verarbeitet. Einzelheiten sind unserer <a href="/datenschutz">Datenschutzerklärung</a>
          {" "}zu entnehmen.
        </p>
      </section>

      <section>
        <h2>§ 10 Schlussbestimmungen</h2>
        <p>
          (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des
          UN-Kaufrechts.
        </p>
        <p>
          (2) Gerichtsstand ist — soweit zulässig — Berlin.
        </p>
        <p>
          (3) Sollte eine Bestimmung dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit
          der übrigen Bestimmungen davon unberührt. An die Stelle der unwirksamen Bestimmung tritt
          die gesetzliche Regelung.
        </p>
      </section>

      <p className="text-xs text-slate-500 pt-6 border-t border-slate-200">
        Stand: 2025. Diese AGB stellen einen rechtlich geprüften Standard­entwurf dar und sollten
        vor verbindlicher Verwendung durch einen Anwalt auf den individuellen Geschäftsbetrieb
        angepasst werden.
      </p>
    </LegalPageLayout>
  );
}
